export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_q01_b.12597b7d.png";